import { useEffect } from "react"
import { useSelector } from "react-redux"

import { getTokenLocal, isObjectEmpty } from "../../../helper/utils"
import { useDispatch } from "react-redux"

import { setLoading, setOpenSidebar } from "../../redux/slices/appSlice"

import { ProvidersHeader } from "../../components/Headers"
import {
  ProvidersMain,
  ProvidersMainLeft,
  ProvidersMainLeftBody,
  ProvidersMainLeftBodyFooter,
  ProvidersMainLeftBodyHeader,
  ProvidersMainLeftBodyMain,
  ProvidersMainLeftHeader,
  ProvidersMainRight,
  ProvidersMainRightHeader,
  ProvidersMainRightTable,
} from "./Atom"
import { ProvidersMetricTabs } from "../../components/Tabs"
import { Box, Typography } from "@mui/material"
import { ProvidersMetricsList } from "../../components/List"
import { ProvidersMetricsFilter } from "../../components/Filters"
import { ApplyButton } from "../../components/Button"
import { ProvidersTable } from "../../components/Table"
import ProvidersAPI from "../../../api/providers"
import { useResponseHandle } from "../../hooks"
import { useNavigate } from "react-router-dom"
import {
  setAllProviderColumns,
  setAllProviderMetrics,
  setFilteredProviderMetrics,
  setProvidersData,
  setProvidersGroupList,
  setProvidersList,
  setProvidersOfficeList,
  setProvidersRegionList,
  setProvidersTableData,
  setSelectedProvidersMetricTab,
  setSpecialityList,
} from "../../redux/slices/providersSlice"
import MetricAPI from "../../../api/metric"

const providersAPI = new ProvidersAPI()
const metricAPI = new MetricAPI()

const Providers = () => {
  const dispatch = useDispatch()
  const token: any = getTokenLocal()
  const navigate = useNavigate()

  dispatch(setOpenSidebar(false))

  const selectedSpeciality = useSelector((state: any) => {
    return state.providers.selectedSpeciality
  })

  const selectedProvidersGroups = useSelector((state: any) => {
    return state.providers.selectedProvidersGroups
  })

  const selectedProvidersRegions = useSelector((state: any) => {
    return state.providers.selectedProvidersRegions
  })

  const selectedProvidersOffices = useSelector((state: any) => {
    return state.providers.selectedProvidersOffices
  })

  const selectedProviders = useSelector((state: any) => {
    return state.providers.selectedProviders
  })

  const providersMetricTabs = useSelector((state: any) => {
    return state.providers.providersMetricTabs
  })

  const selectedProvidersMetricTab = useSelector((state: any) => {
    return state.providers.selectedProvidersMetricTab
  })

  const fetchSpecialityList = async () => {
    const response = await providersAPI.getSpecialities(token)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempSpecialityArr: any = []

        result?.data?.forEach((speciality: any) => {
          tempSpecialityArr.push({
            ...speciality,
            label: speciality?.speciality,
          })
        })

        dispatch(setSpecialityList([...tempSpecialityArr]))
      }
    } else {
      navigate("/auth")
    }
  }

  const fetchGroupList = async () => {
    const response = await metricAPI.getMetricGroupsBoarded(token)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempGroupArr: any = []

        result?.data?.forEach((group: any) => {
          tempGroupArr.push({ ...group, label: group?.group_name })
        })

        dispatch(setProvidersGroupList([...tempGroupArr]))
      }
    } else {
      navigate("/auth")
    }
  }
  const fetchRegionList = async () => {
    const requestArr: any = []

    selectedProvidersGroups.forEach((group: any) => {
      requestArr.push(group?.group_sk)
    })
    const response = await metricAPI.getMetricRegionsByGroups(token, requestArr)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempRegionArr: any = []

        result?.data?.regions?.forEach((region: any) => {
          tempRegionArr.push({ ...region, label: region })
        })

        dispatch(setProvidersRegionList([...tempRegionArr]))
      }
    } else {
      navigate("/auth")
    }
  }
  const fetchOfficeList = async () => {
    const requestGroupArr: any = []
    const requestRegionArr: any = []

    selectedProvidersGroups.forEach((group: any) => {
      requestGroupArr.push(group?.group_sk)
    })

    selectedProvidersRegions.forEach((region: any) => {
      requestRegionArr.push(region?.label)
    })

    const response = await metricAPI.getMetricPracticesByRegions(
      token,
      requestGroupArr,
      requestRegionArr,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempOfficeArr: any = []

        result?.data?.forEach((office: any) => {
          tempOfficeArr.push({ ...office, label: office?.name })
        })

        dispatch(setProvidersOfficeList([...tempOfficeArr]))
      }
    } else {
      navigate("/auth")
    }
  }
  const fetchProviderList = async () => {
    const requestArr: any = []

    selectedProvidersOffices.forEach((office: any) => {
      requestArr.push(office?.practice_sk)
    })

    const response = await providersAPI.getProviders(
      token,
      requestArr,
      selectedSpeciality?.speciality,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempProviderArr: any = []

        result?.data?.forEach((provider: any) => {
          tempProviderArr.push({ ...provider, label: provider?.provider_name })
        })

        dispatch(setProvidersList([...tempProviderArr]))
      }
    } else {
      navigate("/auth")
    }
  }

  const fetchMetricList = async () => {
    const response = await providersAPI.getProviderMetricsBySpeciality(
      token,
      selectedSpeciality?.metric_bucket_id,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempProviderMetricArr: any = []

        result?.data?.forEach((metric: any) => {
          tempProviderMetricArr.push({ ...metric, isChecked: false })
        })

        dispatch(setAllProviderMetrics([...tempProviderMetricArr]))
        dispatch(setFilteredProviderMetrics([...tempProviderMetricArr]))
      }
    } else {
      navigate("/auth")
    }
  }

  const fetchProviderData = async (tab: any) => {
    dispatch(setLoading(true))

    const requestGroupArr: any = []
    const requestOfficeArr: any = []
    const requestProviderArr: any = []
    // let requestMetricSet: Set<any> = new Set()

    selectedProvidersGroups.forEach((group: any) => {
      requestGroupArr.push(group?.group_sk)
    })

    selectedProvidersOffices.forEach((office: any) => {
      requestOfficeArr.push(office?.practice_sk)
    })

    selectedProviders.forEach((provider: any) => {
      requestProviderArr.push(provider?.provider_sk)
    })

    // selectedProviderMetrics.forEach((metric: any) => {
    //   requestMetricSet.add(metric?.metric_id)
    // })

    const requestMetricSet = [tab?.metric_id]

    console.log("tab", tab)

    const response = await providersAPI.getProvidersData(
      token,
      requestGroupArr,
      requestOfficeArr,
      requestProviderArr,
      requestMetricSet,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    console.log("result", result)

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(setProvidersData([...result?.data?.table_data]))
        dispatch(setAllProviderColumns([...result?.data?.column_headers]))

        const metricId = tab?.metric_id

        const tempSelectedTab = providersMetricTabs?.find(
          (tempTab: any) => tempTab?.metric_id == metricId,
        )
        dispatch(setSelectedProvidersMetricTab({ ...tempSelectedTab }))

        const tempTableData = result?.data?.table_data[0]

        if (tempTableData) {
          dispatch(
            setProvidersTableData({
              metric_precision: tempTableData?.metric_precision,
              data: [...tempTableData?.data],
            }),
          )
        } else {
          dispatch(setProvidersTableData([]))
        }
      }
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))
  }

  useEffect(() => {
    fetchSpecialityList()
    fetchGroupList()
  }, [])

  useEffect(() => {
    if (selectedProvidersGroups?.length) {
      fetchRegionList()
    }
  }, [selectedProvidersGroups])

  useEffect(() => {
    if (selectedProvidersRegions?.length) {
      fetchOfficeList()
    }
  }, [selectedProvidersRegions])

  useEffect(() => {
    if (selectedProvidersOffices?.length) {
      fetchProviderList()
    }
  }, [selectedProvidersOffices, selectedSpeciality])

  useEffect(() => {
    if (selectedSpeciality) {
      fetchMetricList()
    }
  }, [selectedSpeciality])

  return (
    <Box>
      <ProvidersHeader name="Providers" />
      {/* <ProvidersTabs /> */}
      <ProvidersMain>
        <ProvidersMainLeft>
          <ProvidersMainLeftHeader>
            <Typography color={"#FFFFFF"} fontSize={14} fontWeight={500}>
              Metric Name
            </Typography>
          </ProvidersMainLeftHeader>

          <ProvidersMainLeftBody>
            <ProvidersMainLeftBodyHeader>
              <ProvidersMetricsFilter />
            </ProvidersMainLeftBodyHeader>

            <ProvidersMainLeftBodyMain
            // className="styled-scrollbar-vertical-broad"
            >
              <ProvidersMetricsList />
            </ProvidersMainLeftBodyMain>

            <ProvidersMainLeftBodyFooter>
              <ApplyButton fetchProviderData={fetchProviderData} />
            </ProvidersMainLeftBodyFooter>
          </ProvidersMainLeftBody>
        </ProvidersMainLeft>

        <ProvidersMainRight>
          <ProvidersMainRightHeader>
            <ProvidersMetricTabs fetchProviderData={fetchProviderData} />
          </ProvidersMainRightHeader>
          <ProvidersMainRightTable>
            {isObjectEmpty(selectedProvidersMetricTab) ? (
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Select A Tab
              </Box>
            ) : (
              <ProvidersTable />
            )}
          </ProvidersMainRightTable>
        </ProvidersMainRight>
      </ProvidersMain>
    </Box>
  )
}

export default Providers
